var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-box"},[_vm._l((_vm.tabTypeItem),function(item,index){return _c('span',{key:index + 'tab',staticClass:"tab-item",class:{
      selected: _vm.tabIndex === item.value,
    },on:{"click":function($event){return _vm.switchType(item, index)}}},[_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),_c('span',{staticClass:"tab-underline",style:(_vm.tabLineStyle)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }